import { STATE_INITIAL } from 'Store/commonActions';

import { SMS_AUTH_STATE_PHONE } from './constants';
import type { SMSState } from './types';

const initialState: SMSState = {
  smsCaptchaReferenceToken: null,
  otpLength: 6,
  phoneNumber: '',
  postPhoneNumberState: STATE_INITIAL,
  validateSmsCodeState: STATE_INITIAL,
  validateSmsCodeError: null,
  postPhoneNumberError: null,
  smsAuthState: SMS_AUTH_STATE_PHONE,
  smsSent: false,
  submitSMSCaptchaError: null,
};

export default initialState;
